import styled, { keyframes } from "styled-components";
import { Button } from "reactstrap";

export const Container = styled.div`
  display: flex;
  justify-content: center; /* horizontal */
  align-items: center; /* vertical */
  min-height: 100vh; /* ocupa a tela toda */
  padding: 20px;
  box-sizing: border-box;
`;

export const LogoCanto = styled.img`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 70px;
  @media (max-width: 800px) {
    width: 60px;
    max-width: 180px;
  }

  @media (max-width: 400px) {
    width: 55px;
    max-width: 150px;
  }

  @media (max-width: 355px) {
    width: 50px;
    max-width: 130px;
  }
`;

export const ButtonLogin = styled(Button)`
  width: 100%;
  max-width: 200px;
  padding: 10px;
  border-radius: 25px;
  font-size: 18px;
  background: linear-gradient(
    268.2deg,
    #006eb0 -5.28%,
    #00afef 100%,
    #007dc3 100%
  );
  border: none;

  /* Ajuste da responsividade no botão */
  @media (max-width: 768px) {
    font-size: 16px; /* Diminui o tamanho da fonte do botão em telas menores */
    width: 80%;
  }
`;
export const Card = styled.div`
  position: relative;
  max-width: 720px;
  width: 100%;
  background: linear-gradient(180deg, #ffffff, #f9fbff);
  border-radius: 14px;
  padding: 40px 30px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  text-align: center;

  h1 {
    font-weight: 700;
    color: #004aad;
    margin-bottom: 5px;
    font-size: 28px;
  }

  .note {
    margin-top: 15px;
    font-size: 14px;
    color: #6c757d;
    line-height: 1.5;
  }

  /* 🔽 Mobile */
  @media (max-width: 560px) {
    padding: 25px 18px;

    h1 {
      font-size: 22px;
    }

    .note {
      font-size: 13px;
    }
  }
`;

const popIn = keyframes`
  0% {
    transform: scale(0.6);
    opacity: 0;
  }
  60% {
    transform: scale(1.5);
    opacity: 6;
  }
  100% {
    transform: scale(1);
  }
`;

export const SuccessIcon = styled.div`
  font-size: 64px;
  color: #004aad;
  margin-bottom: 10px;
  animation: ${popIn} 0.7s ease-out;
`;

export const EmailBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: #f1f6ff;
  border-radius: 10px;
  padding: 18px;
  margin-top: 10px;
  text-align: center;

  svg {
    font-size: 26px;
    color: #004aad;
    flex-shrink: 0;
  }

  span {
    font-size: 14px;
    color: #555;
    line-height: 1.4;
  }

  strong {
    display: block;
    font-size: 16px;
    color: #004aad;
  }

  /* 🔽 AJUSTE PARA TELAS PEQUENAS */
  @media (max-width: 560px) {
    flex-direction: column;
    padding: 14px;
    gap: 6px;

    svg {
      font-size: 22px;
    }

    span {
      font-size: 13px;
    }

    strong {
      font-size: 14px;
    }
  }
`;
